module.exports = __webpack_public_path__ + "img/gift-box.fd24a56c.png";